<div class="input-license-modality-wrapper" [class.disabled]="isDisabled" [class.readonly]="isReadonly">
  <div class="input-license-modality-label">
    <i class="input-license-modality-label-image" [nimbusIcon]="icon"></i>
    <div class="input-license-modality-label-text">{{ label }}</div>
    <mat-checkbox [checked]="isSelected" [disabled]="isDisabled"></mat-checkbox>

    @if (isDisabled) {
      <nimbus-tooltip [text]="disabledReasonsList"></nimbus-tooltip>
    }
  </div>

  @if (infoLabel) {
    <div class="input-license-modality-info">
      <nimbus-mat-icon-overlay
        class="input-license-addon-info-overlay"
        position="top-center"
        [icon]="ICONS.INFO_CIRCLE_NEW"
        [textTemplate]="infoLabelTpl"
      >
        <div class="input-license-provisioning-text-body large">
          <span class="provision-text">{{ infoLabel }}</span>
          <br />
          <a class="info-link" rel="noopener" target="_blank" [href]="(TranslationKeys.LinksLuwareGeneral | translate) + '/' + linkValue">
            {{ TranslationKeys.GeneralReadMore | translate }}
          </a>
        </div>
      </nimbus-mat-icon-overlay>
      <ng-template #infoLabelTpl>
        <span>{{ infoLabel }}</span>
      </ng-template>
    </div>
  }
</div>
